// src/config/contentful.js

import { createClient } from 'contentful';

// Contentful configuration
const contentfulConfig = {
  space: process.env.REACT_APP_CONTENTFUL_SPACE_ID || 'ggj9uj3q0k1o',
  accessToken: process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN || 'aqnWFO3ieuU1-FYdQOnFL17NZHKgdt3IUdmAe62R-N8',
  environment: process.env.REACT_APP_CONTENTFUL_ENVIRONMENT || 'master'
};

// Create Contentful client
export const contentfulClient = createClient(contentfulConfig);

// Helper function to get optimized image URL from Contentful
export const getContentfulImageUrl = (imageUrl, options = {}) => {
  if (!imageUrl) return null;
  
  // If it's already a Contentful URL, add optimization parameters
  if (imageUrl.includes('images.ctfassets.net')) {
    const url = new URL(imageUrl);
    
    // Add optimization parameters
    if (options.width) url.searchParams.set('w', options.width);
    if (options.height) url.searchParams.set('h', options.height);
    if (options.quality) url.searchParams.set('q', options.quality);
    if (options.format) url.searchParams.set('fm', options.format);
    if (options.fit) url.searchParams.set('fit', options.fit);
    if (options.focus) url.searchParams.set('f', options.focus);
    
    return url.toString();
  }
  
  // If it's not a Contentful URL, return as-is (for backward compatibility)
  return imageUrl;
};

// Helper function to get responsive image URLs
export const getResponsiveImageUrls = (imageUrl, sizes = [300, 600, 900, 1200]) => {
  if (!imageUrl) return null;
  
  return sizes.map(size => ({
    width: size,
    url: getContentfulImageUrl(imageUrl, { width: size, quality: 80 })
  }));
};

// Helper function to get image with specific dimensions
export const getImageWithDimensions = (imageUrl, width, height, options = {}) => {
  return getContentfulImageUrl(imageUrl, {
    width,
    height,
    fit: 'fill',
    quality: 80,
    ...options
  });
};

export default contentfulClient;
